export function makeShort2() {
    $("#shoppingcart_hover").fadeOut(100);
    $(".shopping_bag").toggleClass("hover-bag").delay(100);
}